export default "__VITE_ASSET__wNVhKBdZ__"